module.exports = __webpack_public_path__ + "static/img/footlogo.0cd4bd67.png";